import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container__1060" }
const _hoisted_2 = { class: "news__tab--wrap max-w-[1000px] mx-auto mb-[32px]" }
const _hoisted_3 = { class: "news__tab" }
const _hoisted_4 = { class: "flex !mb-[44px] !p-0" }
const _hoisted_5 = { class: "w-[50%] text-center" }
const _hoisted_6 = { class: "w-[50%] text-center" }
const _hoisted_7 = { class: "news__tab--content" }
const _hoisted_8 = {
  class: "news__tab--panel",
  "data-tab": "tab1"
}
const _hoisted_9 = { class: "news__subtab--wrap" }
const _hoisted_10 = { class: "news__subtab" }
const _hoisted_11 = { class: "flex flex-wrap gap-[12px] md:gap-[16px_24px] lg:gap-[24px_30px] xl:gap-[24px_32px] !m-0 !p-0" }
const _hoisted_12 = { class: "flex-initial text-center" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "news__tab--panel",
  "data-tab": "tab2"
}
const _hoisted_15 = { class: "news__subtab--wrap" }
const _hoisted_16 = { class: "news__subtab" }
const _hoisted_17 = { class: "flex flex-wrap gap-[12px] md:gap-[16px_24px] lg:gap-[24px_30px] xl:gap-[24px_32px] !m-0 !p-0" }
const _hoisted_18 = { class: "w-[22%] md:w-[17%] lg:w-[14%] text-center" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "txt__notoR14 txt__black text-right !mb-[24px] lg:!mb-[32px]"
}
const _hoisted_21 = {
  key: 1,
  class: "news__items"
}
const _hoisted_22 = ["href", "target", "rel"]
const _hoisted_23 = { class: "news__dateCat mb-[20px] lg:flex lg:align-center" }
const _hoisted_24 = { class: "news__date txt__notoM20 mb-[16px] lg:mb-0 mr-[28px] text-[#8E7902]" }
const _hoisted_25 = { class: "news__tagOuter flex flex-wrap gap-x-[16px] gap-y-[8px]" }
const _hoisted_26 = {
  key: 0,
  class: "flex flex-wrap gap-x-[16px] gap-y-[8px]"
}
const _hoisted_27 = { class: "news__tag txt__notoB12 txt__black" }
const _hoisted_28 = {
  key: 1,
  class: "flex flex-wrap gap-x-[16px] gap-y-[8px]"
}
const _hoisted_29 = { class: "news__tag txt__notoB12 txt__black" }
const _hoisted_30 = { class: "news__title txt__notoM20 txt__black duration-300 group-hover:!text-[#8E7902] leading-[calc(37/20)] lg:leading-[calc(28/20)]" }
const _hoisted_31 = {
  key: 0,
  class: "flex flex-wrap justify-center items-center gap-4 pt-8 pt-[94px] lg:pt-[72px]"
}
const _hoisted_32 = {
  key: 0,
  class: "border border-[#8E7902] w-[42px] h-[42px] text-center bg-[#8E7902] text-white flex items-center justify-center rounded-md"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", _hoisted_5, [
              _createElementVNode("button", {
                class: _normalizeClass(["news__tab--cat txt__notoSB24 w-full h-[56px] lg:h-[66px] text-[#A39021] border-[2px] border-solid border-[#A39021] rounded-[10px_0_0_10px]", $setup.activeMainTab === 'category' ? 'active' : '']),
                "data-tab": "tab1",
                type: "button",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.handleMainTabClick('category')), ["prevent"]))
              }, "カテゴリで探す", 2 /* CLASS */)
            ]),
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("button", {
                class: _normalizeClass(["news__tab--area txt__notoSB24 w-full h-[56px] lg:h-[66px] text-[#749F54] border-[2px] border-solid border-[#749F54] rounded-[0_10px_10px_0]", $setup.activeMainTab === 'city' ? 'active' : '']),
                "data-tab": "tab2",
                type: "button",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.handleMainTabClick('city')), ["prevent"]))
              }, "エリアで探す", 2 /* CLASS */)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("ul", _hoisted_11, [
                    _createElementVNode("li", _hoisted_12, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["news__subtab--cat !leading-[1.2] txt__notoSB16 !text-[12px] lg:!text-[16px] inline-flex items-center justify-center min-h-[36px] lg:min-h-[44px] px-3 py-2 whitespace-nowrap text-[#A39021] border-[1px] border-solid border-[#A39021] rounded-[10px]", $setup.selectedCategoryId === null ? 'active' : '']),
                        "data-tab": "tab1",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.handleCategoryClick(null)), ["prevent"]))
                      }, "すべて", 2 /* CLASS */)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orderedCategoryList, (category) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "flex-initial text-center",
                        key: category.id
                      }, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["news__subtab--cat txt__notoSB16 inline-flex items-center justify-center min-h-[36px] lg:min-h-[44px] px-3 py-2 !leading-[1.2] whitespace-nowrap !text-[12px] lg:!text-[16px] text-[#A39021] border-[1px] border-solid border-[#A39021] rounded-[10px]", $setup.selectedCategoryId === category.id ? 'active' : '']),
                          "data-tab": "tab1",
                          onClick: _withModifiers(($event: any) => ($setup.handleCategoryClick(category.id)), ["prevent"])
                        }, _toDisplayString(category.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_13)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ])
            ], 512 /* NEED_PATCH */), [
              [_vShow, $setup.activeMainTab === 'category']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("ul", _hoisted_17, [
                    _createElementVNode("li", _hoisted_18, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["news__subtab--area txt__notoSB16 !text-[12px] lg:!text-[16px] w-full h-[32px] lg:h-[42px] text-[#749F54] border-[1px] border-solid border-[#749F54] rounded-[10px]", !($setup.selectedCityIds?.length) ? 'active' : '']),
                        "data-tab": "tab2",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.handleCityClick(null)), ["prevent"]))
                      }, "すべて", 2 /* CLASS */)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.flatCityList, (city) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "w-[22%] md:w-[17%] lg:w-[14%] text-center",
                        key: city.id
                      }, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["news__subtab--area txt__notoSB16 !text-[12px] lg:!text-[16px] w-full h-[32px] lg:h-[42px] text-[#749F54] border-[1px] border-solid border-[#749F54] rounded-[10px]", ($setup.selectedCityIds && $setup.selectedCityIds.includes(city.id)) ? 'active' : '']),
                          "data-tab": "tab2",
                          onClick: _withModifiers(($event: any) => ($setup.handleCityClick(city.id)), ["prevent"])
                        }, _toDisplayString(city.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_19)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ])
            ], 512 /* NEED_PATCH */), [
              [_vShow, $setup.activeMainTab === 'city']
            ])
          ])
        ])
      ]),
      ($setup.newsList.length > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_20, "全" + _toDisplayString($setup.meta.total) + "件中、" + _toDisplayString($setup.meta.from) + "件～" + _toDisplayString($setup.meta.to) + "件目", 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      ($setup.newsList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsList, (news) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "border-t-[1px] border-t-solid border-t-[#8E7902] last:border-b-[1px] last:border-b-solid last:border-b-[#8E7902]",
                key: news.id
              }, [
                _createElementVNode("a", {
                  class: "news__item group block px-[20px] py-[24px]",
                  href: $setup.linkFor(news),
                  target: news.external_url ? '_blank' : '_self',
                  rel: news.external_url ? 'noopener noreferrer' : ''
                }, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, _toDisplayString($setup.formatDate(news.publish_at)), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_25, [
                      (news.categories.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news.categories, (category) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "news__tagWrap px-[12px] h-[33px] flex items-center justify-center bg-[#E2D3A9] rounded-[10px]",
                                key: category.id
                              }, [
                                _createElementVNode("div", _hoisted_27, _toDisplayString(category.name), 1 /* TEXT */)
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      (news.cities.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news.cities, (city) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "news__tagWrap px-[12px] h-[33px] flex items-center justify-center bg-[#C7D4B8] rounded-[10px]",
                                key: city.id
                              }, [
                                _createElementVNode("div", _hoisted_29, _toDisplayString(city.name), 1 /* TEXT */)
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _createElementVNode("h3", _hoisted_30, _toDisplayString(news.title), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_22)
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            ($setup.meta.last_page > 1 && $setup.newsList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  ($setup.meta.current_page > 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "w-[42px] h-[42px] md:w-auto px-2 text-[#8E7902] flex items-center justify-center",
                        type: "button",
                        onClick: _withModifiers($setup.goPrev, ["prevent"])
                      }, _cache[4] || (_cache[4] = [
                        _createElementVNode("span", { class: "material-symbols-outlined !text-[16px]" }, "arrow_back_ios", -1 /* CACHED */)
                      ])))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pageNumbers, (pageNumber) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: pageNumber }, [
                      (pageNumber === $setup.meta.current_page)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(pageNumber), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "border border-[#8E7902] w-[42px] h-[42px] text-center text-[#8E7902] flex items-center justify-center rounded-md",
                            type: "button",
                            onClick: ($event: any) => ($setup.page = pageNumber)
                          }, _toDisplayString(pageNumber), 9 /* TEXT, PROPS */, _hoisted_33))
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 128 /* KEYED_FRAGMENT */)),
                  ($setup.meta.current_page < $setup.meta.last_page)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "w-[42px] h-[42px] md:w-auto px-2 text-[#8E7902] flex items-center justify-center",
                        type: "button",
                        onClick: $setup.goNext
                      }, _cache[5] || (_cache[5] = [
                        _createElementVNode("span", { class: "material-symbols-outlined !text-[16px]" }, "arrow_forward_ios", -1 /* CACHED */)
                      ])))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_34, _cache[6] || (_cache[6] = [
            _createElementVNode("p", { class: "txt__notoSB24 txt__black text-center py-[170px] relative" }, "条件に該当するお知らせは見つかりませんでした。", -1 /* CACHED */)
          ])))
    ])
  ]))
}